const langlist = {
  必須エラー: '必須項目です。入力が完了していません。',
  カタカナエラー: 'カタカナで入力してください。',
  郵便1エラー: '正しい郵便番号を入力してください。',
  生年月日エラー: '正しい生年月日を入力してください。',
  電話番号エラー: '正しい電話番号を入力してください。',
  半角エラー: '半角数字を入力してください。',
  メールエラー: '有効なメールアドレスを入力してください。',
  未選択エラー: 'どれか一つを選んでください。',
  urlエラー: '正しいURLを入力してください。',
  サイズエラー: 'ファイルサイズが大きすぎます',
  必須: '必須',
  入力する: '入力する',
  次へ: '次へ',
  戻る: '戻る',
  確認: '入力内容をご確認ください',
  送信: '内容を送信する',
  で便利なフォーム作れます: 'で便利なフォーム作れます！',
  以上: '${dataminlength}文字以上で入力してください。',
  以内: '${datamaxlength}文字以内で入力してください。',
  以上以内: '${dataminlength}文字以上、${datamaxlength}文字以内で入力してください。',
  非公開: '現在非公開のページです。',
  内容確認: '内容確認',
  passwordLimit: '英数、${min}文字以上${max}文字以内で入力してください。',
  compareError: '入力内容が一致しません',
  hankaku: '半角英数で入力してください',
  mixAlphabetNumber: '半角英数${min}～${max}文字の組合せでご入力ください。',
  電話番号桁エラー: '電話番号は10桁もしくは11桁でご入力ください。',
};

module.exports = langlist;
